import React from 'react';

import {css} from 'emotion';
import {get} from 'lodash-es';
import PropTypes from 'prop-types';

import NavMenuList from '../../NavMenuList';
import NavMenuListItem from '../../NavMenuList/NavMenuListItem';
import {AnchorWithTrackEvent} from '../GlobalNav';
import {
  DISTRICT_CONSTANTS,
  PRINCIPAL_CONSTANTS,
  STUDENT_BINDER_CONSTANTS,
  TEACHER_BINDER_CONSTANTS
} from './constants';
import {
  listItemLinkStyle,
  ulPaddingOverride
} from './style';
import {activePageCheck} from './utils';

const propTypes = {
  history: PropTypes.object,
  userProperties: PropTypes.object
};

export const BinderDrawer = (props) => {
  const {
    history,
    userProperties
  } = props;

  const {
    isFreeUser,
    isBinderApprovedPrincipal,
    isUserStateValidated,
    hasActiveProductLicense,
    isAuthorized
  } = userProperties;

  const activeURL = history.location.pathname;

  const districtLeaderBinderItems = () => {
    if (isFreeUser || !isAuthorized || !hasActiveProductLicense) { return null; }

    return (
      <NavMenuListItem
        key={DISTRICT_CONSTANTS.name}
        isHighlighted={activePageCheck(DISTRICT_CONSTANTS.slug, activeURL)}
      >
        <AnchorWithTrackEvent
          aria-current={activePageCheck(DISTRICT_CONSTANTS.slug, activeURL) ? 'page' : null}
          className={css(listItemLinkStyle)}
          actionName="Navigate"
          legacyEventName={`${DISTRICT_CONSTANTS.name}-Navigate`}
          streamProperties={{
            description: `Binder drawer ${DISTRICT_CONSTANTS.name} link`,
          }}
          eventProperties={{
            description: `Binder drawer ${DISTRICT_CONSTANTS.name} link`
          }}
          href={DISTRICT_CONSTANTS.slug}
        >
          {DISTRICT_CONSTANTS.name}
        </AnchorWithTrackEvent>
      </NavMenuListItem>
    );
  };

  const principalBinderItems = () => {
    if (isFreeUser || !isBinderApprovedPrincipal || !isUserStateValidated || !hasActiveProductLicense) { return null; }

    return (
      <NavMenuListItem
        key={PRINCIPAL_CONSTANTS().name}
        isHighlighted={activePageCheck(PRINCIPAL_CONSTANTS(userProperties.isPrincipal?.school?.id).slug, activeURL)}
      >
        <AnchorWithTrackEvent
          aria-current={activePageCheck(PRINCIPAL_CONSTANTS.slug, activeURL) ? 'page' : null}
          className={css(listItemLinkStyle)}
          actionName="Navigate"
          legacyEventName={`${PRINCIPAL_CONSTANTS.name}-Navigate`}
          streamProperties={{
            description: `Binder drawer ${PRINCIPAL_CONSTANTS.name} link`,
          }}
          eventProperties={{
            description: `binder drawer ${PRINCIPAL_CONSTANTS.name} link`
          }}
          href={PRINCIPAL_CONSTANTS(userProperties.isPrincipal?.school?.id).slug}
        >
          {PRINCIPAL_CONSTANTS().name}
        </AnchorWithTrackEvent>
      </NavMenuListItem>
    );
  };


  const studentBinderItems = () => {
    const {
      YOUR_PROGRESS,
      YOUR_WORD_WALL
    } = STUDENT_BINDER_CONSTANTS;

    return (
      <>
        <NavMenuListItem
          key={YOUR_PROGRESS.name}
          isHighlighted={activePageCheck(YOUR_PROGRESS.slug, activeURL)}
        >
          <AnchorWithTrackEvent
            aria-current={activePageCheck(YOUR_PROGRESS.slug, activeURL) ? 'page' : null}
            className={css(listItemLinkStyle)}
            actionName="Navigate"
            legacyEventName={`${YOUR_PROGRESS.name}-Navigate`}
            streamProperties={{
              description: `Binder drawer ${YOUR_PROGRESS.name} link`,
            }}
            eventProperties={{
              description: `binder drawer ${YOUR_PROGRESS.name} link`
            }}
            href={YOUR_PROGRESS.slug}
          >
            {YOUR_PROGRESS.name}
          </AnchorWithTrackEvent>
        </NavMenuListItem>
        {userProperties.canViewPowerWords ?
          <NavMenuListItem
            key={YOUR_WORD_WALL.name}
            isHighlighted={activePageCheck(YOUR_WORD_WALL.slug, activeURL)}
          >
            <AnchorWithTrackEvent
              aria-current={activePageCheck(YOUR_WORD_WALL.slug, activeURL) ? 'page' : null}
              className={css(listItemLinkStyle)}
              actionName="Navigate"
              legacyEventName={`${YOUR_WORD_WALL.name}-Navigate`}
              streamProperties={{
                description: `Binder drawer ${YOUR_WORD_WALL.name} link`,
              }}
              eventProperties={{
                description: `binder drawer ${YOUR_WORD_WALL.name} link`
              }}
              href={YOUR_WORD_WALL.slug}
            >
              {YOUR_WORD_WALL.name}
            </AnchorWithTrackEvent>
          </NavMenuListItem>
          :
          null}
      </>
    );
  };

  const teacherBinderItems = () => {
    const {
      ACTIVITY_FEED,
      POWER_WORDS,
      READING_SUMMARY,
      SCHOOL_SUMMARY
    } = TEACHER_BINDER_CONSTANTS;

    if (userProperties.isTeacher) {
      return (
        <>
          <NavMenuListItem
            key={READING_SUMMARY.name}
            isHighlighted={activePageCheck(READING_SUMMARY.slug, activeURL)}
          >
            <AnchorWithTrackEvent
              aria-current={activePageCheck(READING_SUMMARY.slug, activeURL) ? 'page' : null}
              className={css(listItemLinkStyle)}
              actionName="Navigate"
              legacyEventName={`${READING_SUMMARY.name}-Navigate`}
              streamProperties={{
                description: `Binder drawer ${READING_SUMMARY.name} link`,
              }}
              eventProperties={{
                description: `binder drawer ${READING_SUMMARY.name} link`
              }}
              href={READING_SUMMARY.slug}
            >
              {READING_SUMMARY.name}
            </AnchorWithTrackEvent>
          </NavMenuListItem>
          <NavMenuListItem
            key={ACTIVITY_FEED.name}
            isHighlighted={activePageCheck(ACTIVITY_FEED.slug, activeURL)}
          >
            <AnchorWithTrackEvent
              aria-current={activePageCheck(ACTIVITY_FEED.slug, activeURL) ? 'page' : null}
              className={css(listItemLinkStyle)}
              actionName="Navigate"
              legacyEventName={`${ACTIVITY_FEED.name}-Navigate`}
              streamProperties={{
                description: `Binder drawer ${ACTIVITY_FEED.name} link`,
              }}
              eventProperties={{
                description: `binder drawer ${ACTIVITY_FEED.name} link`
              }}
              href={ACTIVITY_FEED.slug}
            >
              {ACTIVITY_FEED.name}
            </AnchorWithTrackEvent>
          </NavMenuListItem>
          {userProperties.canViewPowerWords ?
            <NavMenuListItem
              key={POWER_WORDS.name}
              isHighlighted={activePageCheck(POWER_WORDS.slug, activeURL)}
            >
              <AnchorWithTrackEvent
                aria-current={activePageCheck(POWER_WORDS.slug, activeURL) ? 'page' : null}
                className={css(listItemLinkStyle)}
                actionName="Navigate"
                legacyEventName={`${POWER_WORDS.name}-Navigate`}
                streamProperties={{
                  description: `Binder drawer ${POWER_WORDS.name} link`,
                }}
                eventProperties={{
                  description: `binder drawer ${POWER_WORDS.name} link`
                }}
                href={POWER_WORDS.slug}
              >
                {POWER_WORDS.name}
              </AnchorWithTrackEvent>
            </NavMenuListItem> : null}
          {userProperties.hasFeature('view_educator_binder') && get(userProperties, 'schoolId', null) ?
            <NavMenuListItem
              key={SCHOOL_SUMMARY.name}
              isHighlighted={activePageCheck(SCHOOL_SUMMARY.slug, activeURL)}
            >
              <AnchorWithTrackEvent
                aria-current={activePageCheck(SCHOOL_SUMMARY.slug, activeURL) ? 'page' : null}
                className={css(listItemLinkStyle)}
                actionName="Navigate"
                legacyEventName={`${SCHOOL_SUMMARY.name}-Navigate`}
                streamProperties={{
                  description: `Binder drawer ${SCHOOL_SUMMARY.name} link`,
                }}
                eventProperties={{
                  description: `binder drawer ${SCHOOL_SUMMARY.name} link`
                }}
                href={SCHOOL_SUMMARY.slug}
              >
                {SCHOOL_SUMMARY.name}
              </AnchorWithTrackEvent>
            </NavMenuListItem> : null}
        </>
      );
    }
  };

  const renderBinderItems = () => {
    const {
      isDistrictLeader,
      isPrincipal,
      isStudent,
      isTeacher,
    } = userProperties;

    if (isStudent) {
      // Students will never see the other items that
      // are exposed for school administrative staff
      return studentBinderItems();
    } else {
      // Otherwise, the binder buttons are composed through user roles,
      // a user can have one or many of these:
      // - District items
      // - Principal items
      // - Teacher items
      const binderItems = [];
      if (isDistrictLeader) { binderItems.push(districtLeaderBinderItems()); }
      if (isPrincipal) { binderItems.push(principalBinderItems()); }
      if (isTeacher) { binderItems.push(teacherBinderItems()); }

      return binderItems;
    }
  };

  return (
    <NavMenuList additionalClassName={css(ulPaddingOverride)}>
      {renderBinderItems()}
    </NavMenuList>
  );
};

BinderDrawer.propTypes = propTypes;
export default BinderDrawer;
